/// <reference path="DOMAttached.js" />
/// <reference path="TextResource.js" />
/// <reference path="UrlTemplate.js" />
/// <reference path="TextResource.js" />
/// <reference path="GamesMultiplayerConstruction.js" />

class GamesMultiplayerQuizListItem extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		this.constructionElement = document.getElementById(this.options.construction_element);
		this.teamChooser = this.constructionElement.querySelectorAll('[id*="teamChooserddl"]')[0];
		this.friendsChooser = this.constructionElement.querySelectorAll('[id*="friendsChooserddl"]')[0];
		this.gameSelection = this.constructionElement.querySelector('.gameSelection');
		this.dragonChooser = this.constructionElement.querySelector('.dragonChooser');
		this.friendsChooserContainer = this.constructionElement.querySelector('.friendsChooserContainer');
		this.raceAkiBtnWrapper = this.constructionElement.querySelector('.raceAkiWrapper');
		this.raceAkiButton = this.constructionElement.querySelector('.raceAkiBtn');
		this.akiDifficultyWrapper = this.constructionElement.querySelector('.akiDifficulty');
		this.backButton = this.constructionElement.querySelector('.backButton');
		this.animatedDragon = this.constructionElement.querySelector('.animatedDragon');

		// Get all the buttons that can start the game:
		this.easyAkiButton = this.constructionElement.querySelector('.akiEasyBtn');
		this.mediumAkiButton = this.constructionElement.querySelector('.akiMediumBtn');
		this.hardAkiButton = this.constructionElement.querySelector('.akiHardBtn');
		this.friendButton = this.constructionElement.querySelector('.friendBtn');

		// Note that this list uses a very creative way of mixing local and global static state.
		// Parts of the visual interface are private (e.g., gamePic) and parts of the interface are
		// shared but carry local state (e.g., the below buttons) and parts of the interface are shared
		// but do not carry local state (e.g., the back button).
		// We need to unregister any previously registered event listeners on the shared bits that
		// depend on (previous) local state so that when clicking on them, the wrong game does not
		// open. (This is an extremely questionable pattern but to fix it properly you probably want
		// to rewrite all this in Vue.js in the first place.)
		if (GamesMultiplayerQuizListItem.previous != null) {
			GamesMultiplayerQuizListItem.previous.stopObserveAllListeners(this.easyAkiButton);
			GamesMultiplayerQuizListItem.previous.stopObserveAllListeners(this.mediumAkiButton);
			GamesMultiplayerQuizListItem.previous.stopObserveAllListeners(this.hardAkiButton);
			GamesMultiplayerQuizListItem.previous.stopObserveAllListeners(this.friendButton);
			GamesMultiplayerQuizListItem.previous.stopObserveAllListeners(this.backButton);
		}
		GamesMultiplayerQuizListItem.previous = this;

		this.safeObserve(this.easyAkiButton, 'click', this.onAkiOkClick.bind(this));
		this.safeObserve(this.mediumAkiButton, 'click', this.onAkiOkClick.bind(this));
		this.safeObserve(this.hardAkiButton, 'click', this.onAkiOkClick.bind(this));
		this.safeObserve(this.friendButton, 'click', this.onAkiOkClick.bind(this));
		this.safeObserve(this.raceAkiButton, 'click', this.onRaceAkiClick.bind(this));
		this.safeObserve(document.getElementById(this.options.gamePic), 'click', this.onGamePicClick.bind(this));
		this.safeObserve(this.backButton, 'click', this.showFirstScreen.bind(this));
		window.setTimeout(() => { this.getNextButton(); }, 500);
	}

	getNextButton() {
		this.nextBtnSearch = document.getElementsByClassName("nextBtn");
		if (typeof this.nextBtnSearch != "undefined") {
			this.nextBtn = this.nextBtnSearch[0];
		}
	}

	onAkiOkClick(event) {
		// stop event propagation, i.e. don't reload the page
		event.preventDefault();
		event.stopPropagation();

		// This button shouldn't be clickable more than once.
		this.friendButton.disabled = true;

		//get team
		var teamId = this.teamChooser.options[this.teamChooser.selectedIndex].value;

		//get friend
		var friendId = this.friendsChooser.options[this.friendsChooser.selectedIndex].value;
		GamesMultiplayerConstructionInstance.opponent = this.friendsChooser.options[this.friendsChooser.selectedIndex].text;

		//get level
		var classList = Array.from(event.target.classList);
		this.level = 0;
		if (classList.includes('akiEasyBtn')) {
			this.level = 1;
		}
		if (classList.includes('akiMediumBtn')) {
			this.level = 2;
		}
		if (classList.includes('akiHardBtn')) {
			this.level = 3;
		}
		if (this.level == 0 && friendId == "mem") {
			return false;
		}

		if (this.level == 0 && friendId != "mem") {
			teamId = this.teamChooser.options[0].value;
			var member = [this.options.member_array, friendId];
		} else var member = [this.options.member_array];

		GamesMultiplayerConstructionInstance.level = this.level;

		axios(new UrlTemplate(this.options.create_url).r('PLH_AkiLevel', this.level).r('PLH_team', teamId).r('PLH_Cmem', member).url,{
				method: 'get'
			})
			.then(this.onSuccess.bind(this))
			.catch(this.onError.bind(this));
	}

	showFirstScreen(event) {
		event.preventDefault();
		event.stopPropagation();

		this.backButton.style.display = 'none';
		this.raceAkiBtnWrapper.style.display = 'none';
		this.friendsChooserContainer.style.display = 'none';
		this.akiDifficultyWrapper.style.display = 'none';
		this.animatedDragon.style.display = 'none';

		this.gameSelection.style.display = 'block';
		this.dragonChooser.style.display = 'block';
	}

	showSecondScreen(event) {
		event.preventDefault();
		event.stopPropagation();

		this.gameSelection.style.display = 'none';
		this.dragonChooser.style.display = 'none';
		this.akiDifficultyWrapper.style.display = 'none';
		this.backButton.style.display = 'block';
		this.animatedDragon.style.display = 'block';

		if (this.options.communityPlusEnabled) {
			this.raceAkiBtnWrapper.style.display = 'block';
			this.friendsChooserContainer.style.display = 'block';
		} else {
			this.akiDifficultyWrapper.style.display = 'block';
		}
		this.bindBackButton(this.showFirstScreen);
	}

	showThirdScreen(event) {
		event.preventDefault();
		event.stopPropagation();

		this.raceAkiBtnWrapper.style.display = 'none';
		this.friendsChooserContainer.style.display = 'none';
		this.akiDifficultyWrapper.style.display = 'block';
		this.bindBackButton(this.showSecondScreen);
	}

	bindBackButton(screen) {
		this.stopObserveAllListeners(this.backButton);
		this.safeObserve(this.backButton, 'click', screen.bind(this));
	}

	onGamePicClick(event) {
		this.showSecondScreen(event);
	}

	onRaceAkiClick(event) {
		this.showThirdScreen(event);
	}

	onSuccess(req) {
		GamesMultiplayerConstructionInstance.onSuccess(req);
	}

	onError(req) {
		GamesMultiplayerConstructionInstance.onError(req);
	}
}
